import React from "react";
import "./SortableColumnHeader.css";

const SortableColumnHeader = ({
  sortField,
  sortBy,
  sortOrder,
  onSort,
  className = "",
  children,
}) => {
  const isActive = sortBy?.value === sortField;
  const isCentered = className.includes("text-center");
  const sortIcon = !isActive
    ? "fa-sort"
    : sortOrder?.value === "ASC"
      ? "fa-sort-up"
      : "fa-sort-down";

  return (
    <th
      className={`modern-grid-sortable-th pt-2 pb-2 ${className} ${
        isActive ? "is-sorted" : ""
      }`}
      onClick={() => onSort(sortField)}
      style={{ cursor: "pointer" }}
      title="Click to sort"
    >
      <span
        className={`d-inline-flex align-items-center gap-1 ${
          isCentered ? "w-100 justify-content-center" : ""
        }`}
      >
        {children}
        <i className={`fa ${sortIcon} modern-grid-sort-icon`} aria-hidden="true" />
      </span>
    </th>
  );
};

export default SortableColumnHeader;
